import type { ComponentPropsWithoutRef } from 'react'
import { cn } from '../../utils/cn'

const baseClassName =
  'min-h-[120px] w-full rounded-2xl border border-border/80 bg-white/80 px-3 py-3 text-sm text-ink placeholder:text-muted/70 shadow-sm transition focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30'

type TextareaProps = ComponentPropsWithoutRef<'textarea'>

export function Textarea({ className, ...props }: TextareaProps) {
  return <textarea className={cn(baseClassName, className)} {...props} />
}

